import { experienceQueryKeys as e } from "./useExperienceQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { experiencesApi as n } from "@maat/api-main";
//#region src/experiences/useExperiencesQuery.ts
var r = (r = {}) => t({
	queryKey: e.list(r),
	fetchPage: (e) => n.listExperiences({
		...r,
		page: e
	}),
	key: "items"
});
//#endregion
export { r as useExperiencesQuery };
